<template>
  <v-container fluid grid-list-xl class="pa-0 pt-2">

    <!--<v-layout wrap>-->
      <!--<v-flex xs12 class=" ma-2">-->
        <!--<div class="text-sm-left f-20" color="#002d4a">Grafts</div>-->
      <!--</v-flex>-->
      <!--<v-divider></v-divider>-->
    <!--</v-layout>-->
    <v-layout row wrap>
      <!-- Statistics -->
      <v-flex lg4 sm6 xs12>
        <v-card class="pa-2 card-r shadow-1">
         <pie-chart :data="tearcherData" legend="bottom"></pie-chart>
        </v-card>
      </v-flex>
        <!-- <v-text-field :value="parent.$t('dashboard.AdminDashboard')"></v-text-field> -->
      <v-flex lg4 sm6 xs12>
        <v-card class="pa-2 card-r shadow-1">
          <column-chart :data="studentData" :colors="['#b00']" label="Month" :xtitle="metaInfo.graph2.x_axis" :ytitle="metaInfo.graph2.y_axis"></column-chart>
        </v-card>
      </v-flex>
      <!--<v-flex d-flex lg4 sm6 xs12>-->
        <!--<bar-chart :data="data" :colors="['#75e569']" xtitle="Population"></bar-chart>-->
      <!--</v-flex>-->

      <v-flex lg4 sm6 xs12>
        <v-card class="pa-2 card-r shadow-1">
          <area-chart :data="areaStatisticData" :xtitle="metaInfo.graph3.x_axis" :ytitle="metaInfo.graph3.y_axis" :dataset="{borderWidth: 3}"></area-chart>
        </v-card>
      </v-flex>
      <!--<v-flex d-flex lg4 sm6 xs12>-->
        <!--<scatter-chart :data="scatterStatisticData" xtitle="Size" :colors="['#107250']" ytitle="Population"></scatter-chart>-->
      <!--</v-flex>-->
      <!--<v-flex d-flex lg4 sm6 xs12>-->
        <!--<line-chart :data="lineChartData" :colors="['#8b47d8']" xtitle="Time" ytitle="Population" :dataset="{borderWidth: 3}"></line-chart>-->
      <!--</v-flex>-->

      <!--<v-flex d-flex lg4 sm6 xs12>-->
        <!--<line-chart :data="lineChartData" :colors="['#47d8a5']" :curve="false" xtitle="Time" ytitle="Population" :dataset="{borderWidth: 3}"></line-chart>-->
      <!--</v-flex>-->
      <!--<v-flex d-flex lg4 sm6 xs12>-->
        <!--<pie-chart :data="data" legend="bottom" :donut="true"></pie-chart>-->
      <!--</v-flex>-->
      <!--<v-flex d-flex lg4 sm6 xs12>-->
        <!--<line-chart :data="linearMultipleChartdata" />-->
      <!--</v-flex>-->
      <!-- Statistics Ends -->
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
  import {mapState} from 'vuex'
import { close } from 'fs';
  export default {
    data () {
      return {
        tearcherData: {},
        studentData: {},
        areaStatisticData: {},
        metaInfo:{
          graph2:{
            x_axis:this.$t('dashboard_page.graph2.x_axis'),
            y_axis:this.$t('dashboard_page.graph2.y_axis')
          },
          graph3:{
            x_axis:this.$t('dashboard_page.graph3.x_axis'),
            y_axis:this.$t('dashboard_page.graph3.y_axis')
          }
        }

      }
    },
    updated:function(){
      this.metaInfo.noOfStudents=this.$t('dashboard.graph.NoOfStudents')
      this.metaInfo.Month=this.$t('dashboard.graph.Month')
    },
    beforeCreate:function(){
        Store.dispatch('getEarningChart');
        Store.dispatch('getStudentChart');
        Store.dispatch('getTeacherChart');
    },
    created: function () {
          // Store.dispatch('getEarningChart');
          var earningChart = Store.state.earningChart;
          var earningChartData={
              [earningChart[0].year+"-"+earningChart[0].month_text]:earningChart[0].total_income_from_students,
              [earningChart[1].year+"-"+earningChart[1].month_text]:earningChart[1].total_income_from_students,
              [earningChart[2].year+"-"+earningChart[2].month_text]:earningChart[2].total_income_from_students,
              [earningChart[3].year+"-"+earningChart[3].month_text]:earningChart[3].total_income_from_students,
              [earningChart[4].year+"-"+earningChart[4].month_text]:earningChart[4].total_income_from_students,
              [earningChart[5].year+"-"+earningChart[5].month_text]:earningChart[5].total_income_from_students,
              [earningChart[6].year+"-"+earningChart[6].month_text]:earningChart[6].total_income_from_students,
              [earningChart[7].year+"-"+earningChart[7].month_text]:earningChart[7].total_income_from_students,
              [earningChart[8].year+"-"+earningChart[8].month_text]:earningChart[8].total_income_from_students,
              [earningChart[9].year+"-"+earningChart[9].month_text]:earningChart[9].total_income_from_students,
              [earningChart[10].year+"-"+earningChart[10].month_text]:earningChart[10].total_income_from_students,
              [earningChart[11].year+"-"+earningChart[11].month_text]:earningChart[11].total_income_from_students,
          };
          this.areaStatisticData = earningChartData;

        Store.dispatch('getStudentChart');

        setTimeout(() => {
          var studentChart = Store.state.studentChart;
          var studentChartDate={
              [studentChart[0].year+"-"+studentChart[0].month_text]:studentChart[0].students,
              [studentChart[1].year+"-"+studentChart[1].month_text]:studentChart[1].students,
              [studentChart[2].year+"-"+studentChart[2].month_text]:studentChart[2].students,
              [studentChart[3].year+"-"+studentChart[3].month_text]:studentChart[3].students,
              [studentChart[4].year+"-"+studentChart[4].month_text]:studentChart[4].students,
              [studentChart[5].year+"-"+studentChart[5].month_text]:studentChart[5].students,
              [studentChart[6].year+"-"+studentChart[6].month_text]:studentChart[6].students,
              [studentChart[7].year+"-"+studentChart[7].month_text]:studentChart[7].students,
              [studentChart[8].year+"-"+studentChart[8].month_text]:studentChart[8].students,
              [studentChart[9].year+"-"+studentChart[9].month_text]:studentChart[9].students,
              [studentChart[10].year+"-"+studentChart[10].month_text]:studentChart[10].students,
              [studentChart[11].year+"-"+studentChart[11].month_text]:studentChart[11].students,
          };
          this.studentData = studentChartDate;
        }, 2000);


        // Store.dispatch('getTeacherChart');
        setTimeout(() => {
          var teacherChart = Store.state.teacherChart;
          if(teacherChart.length>0){
            var teacherDateObject = {};
            for (var i=0; i<teacherChart.length;i++) {
                let demo=(teacherChart[i].teacher_name).toString();
                teacherDateObject[demo]= teacherChart[i].canceled_bookings;
            }
            this.tearcherData = teacherDateObject;
          }else{
            this.tearcherData={'nodata':0}
          }

        }, 0);


    },

      computed:{
          ...mapState({
              // tearcherData:"teacherDateObject",
              // studentData:"studentChartDate",
              // areaStatisticData:"earningChartData"

          })

      }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Charts.vue